const EXPORT_TYPE = {
  PPM_EVOUCHER_GIFT_REPORT_BY_ORDER:
    'ppm_list_order_with_evoucher_info_by_promotion',
  PPM_EVOUCHER_GIFT_REPORT_BY_ORDER_REALTIME:
    'ppm_list_order_with_evoucher_info_by_promotion_realtime',
  PPM_EVOUCHER_SUMMARY_REPORT: 'ppm_summary_evoucher_status_origins',
};

export default {
  EXPORT_TYPE,
};
